import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

// import ComingSoon from "./components/ComingSoon";
import Home from "./components/Home";
import Safety from "./components/Safety";
import Tradies from "./components/Tradies";
import HomeMods from "./components/HomeMods";
import Contact from "./components/Contact";


function App() {
  return (
    <Routes>
      {/* <Route path="/" element={<ComingSoon />} /> */}
      <Route path="/" element={<Home />} />
      <Route path="/safety" element={<Safety />} />
      <Route path="/tradies" element={<Tradies />} />
      <Route path="/home-modifications" element={<HomeMods />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  );
}

export default App;